// import React from "react";
// import { Box, Button, Typography } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import bgImage from "../../images/heroImage.jpeg";

// const Banner1 = () => {
//   const navigate = useNavigate();
//   return (
//     <Box
//       sx={{
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         height: "100vh",
//         color: "#000",
//         padding: "20px",
//       }}
//     >
//       {/* Image */}
//       <Box
//         component="img"
//         src={bgImage}
//         alt="Yoga Banner"
//         sx={{
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           objectFit: "cover", // Ensures image covers container without distortion
//           objectPosition: "center", // Centers the image
//           zIndex: -2, // Behind overlay and content
//         }}
//       />
//       {/* Left Box: Headlines */}
//       <Box
//         sx={{
//           width: "50%",
//           padding: "20px",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//         }}
//       >
//         <Typography
//           variant="h2"
//           gutterBottom
//           sx={{
//             fontWeight: "bold",
//             textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
//             marginTop: "80px",
//           }}
//         >
//           YOGAS IS A MEDICINE
//         </Typography>
//         <Typography
//           variant="h5"
//           gutterBottom
//           sx={{
//             fontStyle: "italic",
//             marginBottom: "20px",
//             textAlign: "center",
//             marginTop: "80px",
//           }}
//         >
//           “YOGAS CHITTA VRITTI NIRODHA”
//         </Typography>
//         <Typography
//           variant="body1"
//           paragraph
//           sx={{ fontSize: "1.2rem", lineHeight: 1.8 }}
//         >
//           Yoga is the union of body, mind, and soul. It’s the practice to attain
//           self-realization.
//         </Typography>
//         <Typography
//           variant="body1"
//           paragraph
//           sx={{ fontSize: "1.2rem", lineHeight: 1.5, marginTop: "80px" }}
//         >
//           Regular practice of Yoga allows us to say goodbye to doctors,
//           medicines, and hospitals. Yoga is the master key to joy, peace, and
//           the gift of God.
//         </Typography>

//         {/* Centered Button with Margin */}
//         <Box
//           sx={{ display: "flex", justifyContent: "center", marginTop: "30px" }}
//         >
//           <Button
//             onClick={() => navigate("/contact")}
//             variant="contained"
//             color="secondary"
//             size="large"
//             sx={{
//               padding: "10px 20px",
//               borderRadius: "50px",
//               textTransform: "none",
//               fontWeight: "bold",
//               boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
//               width: "50%", // Adjust the width of the button
//             }}
//           >
//             Contact Us Today
//           </Button>
//         </Box>
//       </Box>

//       {/* Right Box: Images */}
//       {/* <Box
//         sx={{
//           width: "50%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <img
//           src={banner}
//           alt="Yoga Example"
//           style={{
//             maxWidth: "100%",
//             height: "auto",
//             borderRadius: "20px",
//             boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)",
//           }}
//         />
//       </Box> */}
//     </Box>
//   );
// };

// export default Banner1;

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import bgImage from "../../images/heroImage.jpeg";

const Banner1 = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        overflow: "hidden",
        color: "#fff",
      }}
    >
      {/* Background Image */}
      <Box
        component="img"
        src={bgImage}
        alt="Yoga Banner"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100%",
          objectFit: "contai",
          objectPosition: "center",
          zIndex: -2,
        }}
      />

      {/* Optional Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          width: "100%",
          height: "100%",
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: -1,
        }}
      />

      {/* Content */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          height: "100vh",
          padding: "0 20px",
          zIndex: 1,
          color: "#000",
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: "bold",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 1)",
            // textShadow: "2px 2px 4px rgba(255, 255, 255, 1)",
            color: "#000",
            mb: 3,
          }}
        >
          YOGA IS A MEDICINE
        </Typography>

        <Typography
          variant="h5"
          sx={{
            fontStyle: "italic",
            mb: 3,
            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)",
          }}
        >
          “YOGAS CHITTA VRITTI NIRODHA”
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "1.2rem",
            maxWidth: "700px",
            mb: 2,
            lineHeight: 1.8,
          }}
        >
          Yoga is the union of body, mind, and soul. It’s the practice to attain
          self-realization.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "1.2rem",
            maxWidth: "700px",
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          Regular practice of Yoga allows us to say goodbye to doctors,
          medicines, and hospitals. Yoga is the master key to joy, peace, and
          the gift of God.
        </Typography>

        <Button
          onClick={() => navigate("/contact")}
          variant="contained"
          size="large"
          sx={{
            background: "orange",
            padding: "10px 30px",
            borderRadius: "10px",
            fontWeight: "bold",
            textTransform: "none",
            boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.3)",
            transition: "0.3s",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          CONTACT US TODAY
        </Button>
      </Box>
    </Box>
  );
};

export default Banner1;
